@let content = currentRendering.selectors.content.asSignal();
@let container = content?.basic;

<atn-ds-page>
  <atn-mosaic-page-header pageHeader />

  @if (container) {
    <atn-mosaic-page-grid [container]="container" />
  }
</atn-ds-page>
